<template>
  <div class="working">
    <div class="working-card">
      <div class="working-icon" aria-hidden="true">
        <span class="gear gear-lg">⚙</span>
        <span class="gear gear-sm">⚙</span>
      </div>

      <span class="working-badge">점검 안내</span>
      <h1 class="working-title">{{ title }}</h1>
      <p class="working-desc" v-html="desc"></p>

      <div class="working-period">
        <span class="label">작업 기간</span>
        <span class="value">{{ workingDate }}</span>
        <span v-if="note" class="note">{{ note }}</span>
      </div>

      <p class="working-thanks">이용에 불편을 드려 죄송합니다. 감사합니다.</p>
    </div>

    <p class="working-footer">COPYRIGHTⓒ2023 BY KIST ALL RIGHTS RESERVED</p>
  </div>
</template>

<script>
// 점검 내용은 여기 변수만 수정 (켜고 끄기는 router/index.ts 의 workingIng)
export default {
  data() {
    return {
      title: "서버 이관 작업 중입니다",
      desc: "보다 안정적인 서비스 제공을 위해<br/>서버 이관 작업을 진행하고 있습니다.",
      workingDate: "2026-10-03 ~ 2026-10-05",
      note: "※ 작업 상황에 따라 조기 종료될 수 있습니다.",
    };
  },
};
</script>

<style scoped>
.working {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(160deg, #f4f9fd 0%, #dfecf5 100%);
  font-family: "notokr", "맑은고딕", "Malgun Gothic", sans-serif;
  color: #222;
  word-break: keep-all;
}
.working-card {
  width: 100%;
  max-width: 540px;
  padding: 48px 40px 40px;
  background: #fff;
  border-top: 4px solid #003f67;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0, 63, 103, 0.12);
  text-align: center;
}
.working-icon {
  position: relative;
  width: 96px;
  height: 80px;
  margin: 0 auto 20px;
  color: #05578a;
}
.gear {
  position: absolute;
  line-height: 1;
  animation: spin 6s linear infinite;
}
.gear-lg {
  left: 0;
  top: 0;
  font-size: 64px;
}
.gear-sm {
  right: 0;
  bottom: 0;
  font-size: 40px;
  opacity: 0.6;
  animation-direction: reverse;
  animation-duration: 4s;
}
.working-badge {
  display: inline-block;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 700;
  color: #05578a;
  background: #e8f2f9;
  border-radius: 999px;
}
.working-title {
  margin: 12px 0 16px;
  font-size: 26px;
  font-weight: 700;
  color: #003f67;
}
.working-desc {
  font-size: 15px;
  line-height: 1.8;
  color: #555;
}
.working-period {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 28px;
  padding: 18px 16px;
  background: #f8fcff;
  border: 1px solid #dbe8f2;
  border-radius: 8px;
}
.working-period .label {
  font-size: 13px;
  font-weight: 700;
  color: #05578a;
}
.working-period .value {
  font-size: 17px;
  font-weight: 600;
}
.working-period .note {
  font-size: 13px;
  color: #d9534f;
}
.working-thanks {
  margin-top: 24px;
  font-size: 14px;
  color: #777;
}
.working-footer {
  margin-top: 24px;
  font-size: 12px;
  color: #999;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .gear {
    animation: none;
  }
}
</style>
